export const format = (number: number) => Math.round(number);
